import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

import { AuthenticationService } from '../services/auth.service';

@Injectable()
export class AdminGuard implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthenticationService
  ) {}

  async canActivate() {
    const user = this.authService.getCurrentUser();

    if (user && user.isAdmin) {
      return true;
    } else {
      await this.router.navigate(['/']);
      return false;
    }
  }
}
